import { render, staticRenderFns } from "./DashboardFeedback.vue?vue&type=template&id=6883c46e&"
import script from "./DashboardFeedback.vue?vue&type=script&lang=js&"
export * from "./DashboardFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports